module.exports = __webpack_public_path__ + "img/sore.adb7caa3.png";